module.exports = __webpack_public_path__ + "img/etfs.0335ff42.svg";